import React from 'react';
import logoImg from '../assets/logo.png';

export default function Register({ setAuthView, handleLogin }) {
  const onSubmit = (e) => {
    e.preventDefault();
    alert("Account created successfully!");
    handleLogin();
  };

  return (
    <div className="auth-card">
      <div className="auth-header">
        <img src={logoImg} alt="Logo" />
        <h2>Create Account</h2>
        <p>Register as a new administrator</p>
      </div>
      <form onSubmit={onSubmit} style={{ overflow: 'visible' }}>
        <div className="form-group full-width">
          <label>Full Name</label>
          <input type="text" required placeholder="e.g. Adeeb" />
        </div>
        <div className="form-group full-width" style={{ marginTop: '15px' }}>
          <label>Email Address</label>
          <input type="email" required placeholder="admin@swimmersacademy.com" />
        </div>
        <div className="form-group full-width" style={{ marginTop: '15px' }}>
          <label>Password</label>
          <input type="password" required placeholder="••••••••" />
        </div>
        <button type="submit" className="submit-btn" style={{ marginTop: '25px', width: '100%' }}>
          <i className="fas fa-user-plus"></i> Register
        </button>
      </form>
      <div className="auth-links" style={{ justifyContent: 'center' }}>
        <span onClick={() => setAuthView('login')}>Already have an account? Login</span>
      </div>
    </div>
  );
}